import React from "react";

export default function TopBar() {
    return <div className="topbar" />;
}
